<template>
  <div class="console_r">
    <!-- <sub-header :id="queryParams.hennery_id" name="env"></sub-header> -->
    <div class="console_r_card">
      <div class="title">
        <b>{{currHenneryName}} - 环境指数<i @click="refresh" class="el-icon-refresh" title="刷新"></i></b>
        <!-- <span>当前记录：{{count}}</span> -->
      </div>
      <div class="con">
        <div class="con_top" style="padding: 50px 0;">
          <el-date-picker
            style="width: 240px"
            v-model="startTime"
            @change="(e) => dateChange(1, e)"
            type="date"
            value-format="timestamp"
            placeholder="选择开始时间">
          </el-date-picker>
          <el-date-picker
            style="width: 240px"
            v-model="endTime"
            @change="(e) => dateChange(2, e)"
            type="date"
            value-format="timestamp"
            placeholder="选择结束时间">
          </el-date-picker>
          <el-button type="primary" @click="searchChart" round>查询</el-button>
        </div>
        <div v-for="(item, index) in chartData" :key="index">
          <div class="chart">
            <div class="chart-top">
              <span class="chart-title">鸡场{{titleMap[item.key].name}}分析图</span>
              <span v-if="titleMap[item.key].subName" class="chart-sub-title"><br />{{titleMap[item.key].subName}}</span>
            </div>
            <line-chart :chart-data="item.henneryData" :unit="titleMap[item.key].unit" :min="item.min" :max="item.max" />
          </div>
          <div class="chart">
            <div class="chart-top">
              <el-dropdown @command="handleCommand">
                <span class="chart-title">{{!!currBuilding ? currBuilding.name : ''}}{{titleMap[item.key].name}}分析图<i class="el-icon-arrow-down el-icon--right"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in buildingList" :key="index" :command="item">{{item.name}}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span v-if="titleMap[item.key].subName" class="chart-sub-title"><br />{{titleMap[item.key].subName}}</span>
            </div>
            <line-chart :chart-data="item.buildingData" :unit="titleMap[item.key].unit" :min="item.min" :max="item.max" />
          </div>
        </div>
      </div>
      <!-- <div style="text-align: center">
        <el-pagination
        style="padding: 20px 0 40px"
        background
        layout="prev, pager, next"
        @current-change="currPageChange"
        :page-size="queryParams.limit"
        :total="count">
        </el-pagination>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import moment from '@/libs/moment'
import { getHenneryEnvIndexApi, getBuildingEnvIndexApi, getBuildingListApi } from '@/api/user'
import LineChart from '@/components/charts/LineChart.vue'
import SubHeader from '@/components/SubHeader'

export default {
  name: 'Env',
  components: {
    LineChart,
    // SubHeader
  },
  data() {
    return {
      currHenneryName: '',
      currAct: 'env',
      currHenneryId: Number(this.$route.params.id),
      queryParams: {
        // skip: 0,
        // limit: 100,
        start_time: null,
        end_time: null,
        hennery_id: ''
        // id: 4
      },
      list: [],
      count: 0,
      startTime: null,
      endTime: null,
      oneDayTime: 60 * 60 * 24 * 1000,
      tableDateList: [],
      xData: [],
      emptyData: [],
      titleMap: {
        temperature: {
          name: '温度',
          unit: '℃'
        },
        air_index: {
          name: '空气质量指数',
          subName: '严重污染：0~60，疑似污染：60~80，无污染：80~100',
          unit: ''
        },
        humidity: {
          name: '湿度',
          unit: '%'
        },
        pressure: {
          name: '大气压强',
          unit: 'hPa'
        }
      },
      chartData: [
        {
          key: 'temperature',
          min: 15,
          max: 40,
          henneryData: {
            xData: [],
            yData: null
          },
          buildingData: {
            xData: [],
            yData: null
          },
        },
        {
          key: 'air_index',
          min: 0,
          max: 100,
          henneryData: {
            xData: [],
            yData: null
          },
          buildingData: {
            xData: [],
            yData: null
          },
        },
        {
          key: 'humidity',
          min: 0,
          max: 100,
          henneryData: {
            xData: [],
            yData: null
          },
          buildingData: {
            xData: [],
            yData: null
          },
        },
        {
          key: 'pressure',
          min: 900,
          max: 1030,
          henneryData: {
            xData: [],
            yData: null
          },
          buildingData: {
            xData: [],
            yData: null
          },
        }
      ],
      buildingList: [],
      currBuilding: null,
    }
  },
  methods: {
    handleCommand (command) {
      if(this.currBuilding.id === command.id) return
      this.currBuilding = command
      this.getBuildingEnvIndexData()
    },
    dateChange (type, e) {
      console.log(type, e)
      if(e) {
        // this.queryParams.start_time = moment(e).valueOf()
        // this.queryParams.end_time = this.queryParams.start_time + this.oneDayTime
        // this.getHenneryLivenessData()
        // this.getBuildingLivenessData()
        if (type === 1) {
          this.queryParams.start_time = this.startTime
        } else if (type === 2) {
          this.queryParams.end_time = this.endTime + this.oneDayTime
        }
      }
    },
    lineItem (name, data) {
      // data.forEach(item => {
      //   item += unit
      // })
      // console.log('dddd', data)
      return {
        name: name,
        type: 'line',
        data: data,
        connectNulls: true,
        // label: {
        //   normal: {
        //     show: true,
        //     "formatter": (a) => {
        //       return a.value.toLocaleString() + 'ddd'
        //     }
        //   }
        // }
      }
    },
    getHenneryEnvIndexData () {
      this.chartData.forEach(item => {
        item.henneryData.yData = null
      })
      getHenneryEnvIndexApi(this.queryParams).then(res=>{
        let data = res.data.data
        this.chartData.forEach(item => {
          item.henneryData.yData = []
        })
        this.chartData.forEach(item => {
          // item.henneryData.unit = this.titleMap[item.key].unit
          // item.henneryData.yData.push(this.lineItem('总鸡场', data[`hennery_${item.key}`]))
          if(data.building_env && data.building_env.length > 0) {
            data.building_env.forEach(bl => {
              item.henneryData.yData.push(this.lineItem(bl.name, bl[item.key]))
            })
          }
        })
      }).catch(() => {
        // this.loadingData = false
        this.chartData.forEach(item => {
          item.henneryData.yData = []
        })
      })
    },
    getBuildingEnvIndexData () {
      this.chartData.forEach(item => {
        item.buildingData.yData = null
      })
      getBuildingEnvIndexApi({...this.queryParams, building_id: this.currBuilding.id}).then(res => {
        let data = res.data.data
        this.chartData.forEach(item => {
          item.buildingData.yData = []
        })
        this.chartData.forEach(item => {
          // item.buildingData.unit = this.titleMap[item.key].unit
          // item.buildingData.yData.push(this.lineItem('总栋', data.building_env[item.key]))
          if(data.device_env && data.device_env.length > 0) {
            data.device_env.forEach(dl => {
              let name = dl.device_custom_name ? dl.device_custom_name : dl.device_hostname
              item.buildingData.yData.push(this.lineItem(name, dl[item.key]))
            })
          }
        })
      }).catch(() => {
        this.chartData.forEach(item => {
          item.buildingData.yData = []
        })
      })
      // console.log('this.buildingData', this.buildingData)
    },
    getBuildingList () {
      getBuildingListApi({
        skip: 0,
        limit: 100,
        hennery_id: this.queryParams.hennery_id
      }).then(res=>{
        let data = res.data.data.buildings
        this.currHenneryName = res.data.data.hennery.name
        if(!data || data.length <= 0) {
          return
        }
        this.buildingList = data.sort((a, b) => a.name.localeCompare(b.name))
        if(!this.currBuilding) this.currBuilding = this.buildingList[0]
        // if(!this.currBuildingId) {
        //   this.currBuildingId = this.buildingList[0].id
        //   this.currBuildingName = this.buildingList[0].name
        // }
        this.getBuildingEnvIndexData()
      })
    },
    refresh () {
      this.getHenneryEnvIndexData()
      this.getBuildingList()
    },
    searchChart () {
      if(this.queryParams.end_time - this.queryParams.start_time > this.oneDayTime * 31) {
        Message.error('时间范围不可超过31天')
        return
      }
      this.getXData()
      this.getHenneryEnvIndexData()
      this.getBuildingEnvIndexData()
    },
    getXData () {
      this.xData = []
      for(let i=this.queryParams.start_time; i<this.queryParams.end_time; i+=60*10*1000) {
        this.xData.push(moment(i).format('YYYY-MM-DD HH:mm'))
        this.emptyData.push(0)
      }
      this.chartData.forEach(item => {
        item.henneryData.xData = this.xData
        item.buildingData.xData = this.xData
      })
    },
  },
  watch: {
  },
  created(){
    this.$store.commit('setCurrHenneryId', this.$route.params.id)
    let now = moment().format('YYYY-MM-DD')
    this.endTime = moment(`${now} 00:00:00`).valueOf()
    this.queryParams.hennery_id = this.currHenneryId
    this.queryParams.start_time = this.endTime
    this.queryParams.end_time = this.queryParams.start_time + this.oneDayTime
    this.startTime = this.endTime
    this.endTime = this.endTime
    this.refresh()
    this.getXData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'poultry.scss';
.chart {
  padding-bottom: 20px;
  .chart-top {
    // display: flex;
    // justify-content: center;
    text-align: center;
    .chart-title {
      cursor: pointer;
      color: #6ab8ff;
      font-weight: bold;
      font-size: 18px;
    }
    .chart-sub-title {
      color: #3b81c2;
      font-size: 14px;
    }
  }
}
.switch-day {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  text-align: center;
  padding: 20px 0;
}
.bar-mark {
  display: flex;
  justify-content: center;
  align-items: center;
  .bar-mark-item {
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 0 15px;
    .bar-mark-color {
      width: 30px;
      height: 15px;
      margin-right: 2px;
    }
    .bar-mark-name {
      color: #aab6e4;
    }
  }
}
.time-scroll {
  overflow: auto;
  .time-axis {
    // display: flex;
    white-space: nowrap;
    padding: 100px 50px;
    .time-axis-item {
      display: inline-block;
      .item-bar {
        width: 5px;
        height: 30px;
        background-color: gray;
        position: relative;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .item-scale {
          width: 100px;
          text-align: center;
          position: absolute;
          right: -45px;
          top: 30px;
          // background-color: blue;
          &::after {
            content: '';
            display: inline-block;
            width: 1px;
            height: 5px;
            background-color: #ffffff;
            position: absolute;
            left: 50px;
            top: 0;
          }
        }
      }
    }
  }
}
</style>
